import { Shield, Users, Eye, Check, X, Star } from "lucide-react";

const RoleInfoModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto" onClick={onClose}>
      <div className="mc-card p-6 sm:p-8 w-full max-w-2xl my-8 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="role-info-modal">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-['Oswald'] font-bold text-white">GRUPPEFORKLARING</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white p-1" data-testid="close-role-info-x">
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-gray-400 text-sm mb-6">
          Oversigt over de tre rolleniveauer og deres adgang. Sider markeret med <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /> er kun synlige for indloggede medlemmer — offentligheden kan ikke se dem.
        </p>

        {/* Gruppe 1 */}
        <div className="mb-6 mc-card p-5 border-purple-500/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-purple-600/20 flex items-center justify-center">
              <Shield className="w-5 h-5 text-purple-400" />
            </div>
            <div>
              <h3 className="text-lg font-['Oswald'] font-bold text-purple-400">GRUPPE 1 — ADMINISTRATOR</h3>
              <p className="text-gray-500 text-xs">Fuld adgang til hele systemet</p>
            </div>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-gray-300 font-medium mb-2">Kan alt hvad Gruppe 2 og 3 kan, plus:</p>
            <div className="grid gap-1.5">
              {[
                "Oprette invitationskoder til nye medlemmer",
                "Se og administrere alle medlemmer (roller, koder, deaktiver, slet)",
                "Se login-historik og aktivitetsstatistik",
                <>Oprette, redigere og slette produkter i Webshop <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                "Styre Live-sektionen på forsiden",
                "Håndtere bookingforespørgsler og kontaktbeskeder",
                "Administrere klubmedlemmer (offentlig visning)",
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-purple-400 mt-0.5 flex-shrink-0" /><span className="text-gray-300">{text}</span></div>
              ))}
            </div>
          </div>
        </div>

        {/* Gruppe 2 */}
        <div className="mb-6 mc-card p-5 border-blue-500/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-blue-600/20 flex items-center justify-center">
              <Users className="w-5 h-5 text-blue-400" />
            </div>
            <div>
              <h3 className="text-lg font-['Oswald'] font-bold text-blue-400">GRUPPE 2 — REDAKTØR</h3>
              <p className="text-gray-500 text-xs">Kan redigere indhold, men ikke administrere</p>
            </div>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-gray-300 font-medium mb-2">Kan alt hvad Gruppe 3 kan, plus:</p>
            <div className="grid gap-1.5">
              <div className="flex items-start gap-2"><Check className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" /><span className="text-gray-300">Oprette og redigere events i kalenderen</span></div>
              <div className="flex items-start gap-2"><Check className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" /><span className="text-gray-300">Oprette albums og uploade billeder til galleriet</span></div>
            </div>
            <p className="text-gray-300 font-medium mt-3 mb-2">Kan IKKE:</p>
            <div className="grid gap-1.5">
              {[
                "Administrere medlemmer eller ændre roller",
                "Oprette eller slette produkter i Webshop",
                "Styre Live-sektionen",
                "Se eller oprette invitationskoder",
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-2"><X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" /><span className="text-gray-400">{text}</span></div>
              ))}
            </div>
          </div>
        </div>

        {/* Gruppe 3 */}
        <div className="mb-6 mc-card p-5 border-green-500/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-green-600/20 flex items-center justify-center">
              <Users className="w-5 h-5 text-green-400" />
            </div>
            <div>
              <h3 className="text-lg font-['Oswald'] font-bold text-green-400">GRUPPE 3 — MEDLEM</h3>
              <p className="text-gray-500 text-xs">Standard medlemsadgang</p>
            </div>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-gray-300 font-medium mb-2">Har adgang til:</p>
            <div className="grid gap-1.5">
              {[
                <>Medlemsområde <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                <>Webshop — se og købe produkter <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                <>Spil (Lykkehjulet) <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                "Ændre sin egen personlige adgangskode",
                "Se kalender, galleri og offentlige sider",
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" /><span className="text-gray-300">{text}</span></div>
              ))}
            </div>
            <p className="text-gray-300 font-medium mt-3 mb-2">Kan IKKE:</p>
            <div className="grid gap-1.5">
              <div className="flex items-start gap-2"><X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" /><span className="text-gray-400">Redigere events eller galleri</span></div>
              <div className="flex items-start gap-2"><X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" /><span className="text-gray-400">Administrere produkter, medlemmer eller roller</span></div>
            </div>
          </div>
        </div>

        {/* Offentlig adgang */}
        <div className="mc-card p-5 border-gray-600/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-gray-600/20 flex items-center justify-center">
              <Eye className="w-5 h-5 text-gray-400" />
            </div>
            <div>
              <h3 className="text-lg font-['Oswald'] font-bold text-gray-400">OFFENTLIGHEDEN (IKKE LOGGET IND)</h3>
              <p className="text-gray-500 text-xs">Hvad alle kan se uden login</p>
            </div>
          </div>
          <div className="space-y-2 text-sm">
            <div className="grid gap-1.5">
              {["Hjem / Forside", "Kalender", "Klubben", "Book Os", "Galleri", "Mediegarage", "Medlemmer (offentlig visning)", "Andre klubber", "Kontakt & Find os", "Ansøg Medlemskab"].map((text, i) => (
                <div key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" /><span className="text-gray-400">{text}</span></div>
              ))}
            </div>
            <p className="text-gray-300 font-medium mt-3 mb-2">Kan IKKE se:</p>
            <div className="grid gap-1.5">
              {[
                <>Medlemsområde <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                <>Webshop <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
                <>Spil (Lykkehjulet) <Star className="w-4 h-4 text-yellow-400 fill-yellow-400 inline-block align-text-bottom" /></>,
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-2"><X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" /><span className="text-gray-400">{text}</span></div>
              ))}
            </div>
          </div>
        </div>

        <button onClick={onClose} className="w-full mt-6 chrome-btn py-3 rounded-xl font-['Oswald'] uppercase tracking-wider" data-testid="close-role-info-btn">
          Luk
        </button>
      </div>
    </div>
  );
};

export default RoleInfoModal;
